"use strict";

exports.__esModule = true;
var _Panel = require("./Panel");
Object.keys(_Panel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Panel[key]) return;
  exports[key] = _Panel[key];
});